module.exports = __webpack_public_path__ + "static/media/extinction_day.934c8e55.mp3";